import { assocPath } from 'ramda';

import { Action, ActionMeta } from 'src/models';

export const makeUpdatedAction = (action: Action): Action => assocPath(['meta', 'isUpdate'], true, action);

// wrap payload and meta into action form to meet function's param type requirement
export const actionWrapper = <T>(payload: T, meta?: ActionMeta) => ({ type: '', payload, meta });
